import { useEffect, useState } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function InputSelectoForm({ datos, defaultValue, titulo, name, labels = {}, onInputChange }) {
    const [value, setValue] = useState(defaultValue);

    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);


    const handleChange = ({ target: { name, value } }) => {
        onInputChange({ [name]: value })
    };
    return (
        <div className="w-full">
            <FormControl fullWidth>
                <InputLabel id={`brightness${name}`}>{titulo}</InputLabel>

                <Select
                    labelId={`brightness${name}`}
                    name={`brightness${name}`}
                    value={value}
                    label={titulo}
                    onChange={handleChange}
                >
                    {Object.entries(labels).map(([key, val]) => (
                        <MenuItem key={key} value={datos[key]}>
                            {val ?? key} {/* Texto mostrado */}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    )
}
